import { AuthenticatedUserPayload } from '@okcargo/query-processor';
import { ECapabilities, ERoles, IAccount, ICompany } from '../domain/account.model';

export function transformToIAccount(
  accountResponse: any, // TODO fix it when AccountResponse has authUserPayload
  account: IAccount,
): IAccount {
  account.capabilities.push(ECapabilities.AUTHENTICATED);

  account.id = accountResponse.id ?? account.id;
  account.firstName = accountResponse.authUserPayload.firstName ?? account.firstName;
  account.lastName = accountResponse.authUserPayload.lastName ?? account.lastName;
  account.email = accountResponse.authUserPayload.email ?? account.email;
  account.username = accountResponse.authUserPayload.email ?? account.username; // TODO review

  account.lang = 'es'; //accountResponse.langKey?.toLowerCase() ?? account.lang; // TODO Review langKey

  account.company = transformToICompany(accountResponse.authUserPayload);

  const authorities = accountResponse.authUserPayload.capabilities;

  if (Array.isArray(authorities)) {
    if (authorities.includes('ROLE_ADMINISTRATIVE')) {
      account.role = ERoles.BILLING;
      account.capabilities.push(ECapabilities.BILLING);
    }
    if (authorities.includes('ROLE_OKCARGO')) {
      account.role = ERoles.OPERATIONS;
      account.capabilities.push(ECapabilities.OPERATIONS);
    }
    if (authorities.includes('ROLE_COMMERCIAL')) {
      account.role = ERoles.SALES;
      account.capabilities.push(ECapabilities.SALES);
    }
    if (authorities.includes('ROLE_MANAGEMENT')) {
      account.role = ERoles.MANAGEMENT;
      account.capabilities.push(ECapabilities.MANAGEMENT);
    }
  }
  console.log('account.role', account.role);
  console.log('account.capabilities', account.capabilities);

  return account;
}

function transformToICompany(payload: AuthenticatedUserPayload): ICompany {
  const isInternational = /^[a-zA-Z]{2}/.test(payload.companyTaxId);
  const isNotES = !/^ES$/i.test(payload.companyTaxId.substring(0, 2));

  return {
    id: payload.companyId,
    name: payload.companyName,
    taxNumber: payload.companyTaxId,
    streetAddress: payload.companyStreet,
    postalCode: payload.companyPostalCode,
    city: payload.companyCity,
    stateProvince: payload.companyState,
    country: payload.companyCountry,
    phone: payload.companyPhone,
    // TODO
    activated: true,
    isInternational: isInternational && isNotES,
  };
}
